import type { ReactElement } from 'react';
import { Knapp } from '../komponenter/Knapp.js';
import { loggInn } from '../auth/oidc.js';

/**
 * The unauthenticated landing page.
 *
 * There is no username or password field here, and there never will be: this app
 * does not handle credentials at all. The button hands the user to the identity
 * broker, which is where authentication (and MFA) happens.
 */
export function Innlogging(): ReactElement {
  return (
    <main className="flex min-h-screen items-center justify-center bg-flate-dempet px-6">
      <div className="w-full max-w-md rounded-lg border border-kant bg-flate p-8 shadow-kort">
        <h1 className="text-2xl font-semibold text-tekst">Enklere styring</h1>
        <p className="mt-2 text-sm text-tekst-dempet">
          Økonomisk styring for kommunal helse og omsorg. Logg inn med kontoen kommunen har gitt
          deg.
        </p>
        <Knapp storrelse="stor" className="mt-6 w-full" onClick={() => void loggInn()}>
          Logg inn
        </Knapp>
        <p className="mt-4 text-xs text-tekst-dempet">
          Har du ikke tilgang? Be en administrator i kommunen om å opprette en bruker for deg.
        </p>
      </div>
    </main>
  );
}
